var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PartsIE"},[_c('img',{staticClass:"PartsIE-img",attrs:{"src":"https://formation.bienvenue.pro/images/Illustrations/eastwood-fatal-error.png","alt":"not found"}}),_c('div',{staticClass:"PartsIE-error"},[_vm._v(_vm._s(_vm.$t('part.ie.title')))]),_c('div',{staticClass:"PartsIE-msg"},[_vm._v(_vm._s(_vm.$t('part.ie.msg')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }